import { providerAuthClient } from '@/http/client';
import { LoginUserRequestBody } from 'bff';

export const credentialsResendAccountVerification = async ({
  body,
}: {
  body: LoginUserRequestBody;
}) =>
  await providerAuthClient
    .post(body, '/v1/auth/verification/resend/credentials')
    .json();
